export default __webpack_public_path__ + "static/media/i (32).085fe911.jpg";